export const SET_ACCESS_TOKEN = 'accessToken/SET_ACCESS_TOKEN';
export const SET_PROCESSED_SCOPES = 'accessToken/SET_PROCESSED_SCOPES';

export const SET_REMOTE_FEATURE_FLAGS = 'accessToken/SET_REMOTE_FEATURE_FLAGS';

export const SET_MFA_CREDENTIALS = 'accessToken/SET_MFA_CREDENTIALS';
